import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const solutionsLinks = [{
  name: 'Managed WordPress Hosting',
  href: 'https://g7cloud.com/wordpress-hosting/'
}, {
  name: 'Managed WooCommerce Hosting',
  href: 'https://g7cloud.com/woocommerce-hosting/'
}, {
  name: 'Enterprise Managed WordPress Hosting',
  href: 'https://g7cloud.com/enterprise-wordpress-hosting/'
}];
const featuresLinks = [{
  name: 'G7 Acceleration Network',
  href: 'https://g7cloud.com/acceleration-network/'
}, {
  name: 'WordPress Performance',
  href: 'https://g7cloud.com/wordpress-performance/'
}, {
  name: 'WordPress Security',
  href: 'https://g7cloud.com/wordpress-security/'
}, {
  name: 'WordPress Maintenance',
  href: 'https://g7cloud.com/wordpress-maintenance/'
}, {
  name: 'G7 Difference',
  href: 'https://g7cloud.com/g7-difference/'
}, {
  name: 'How Onboarding Works',
  href: 'https://g7cloud.com/how-onboarding-works/'
}, {
  name: 'Email on Your Domain',
  href: 'https://g7cloud.com/email-hosting/'
}];
export function G7CloudHeader() {
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  return <motion.header initial={{
    opacity: 0,
    y: -8
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    ease: 'easeOut'
  }} className="w-full bg-white shadow-sm sticky top-0 z-50" data-id="element-15">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <div className="flex justify-between items-center h-20" data-id="element-17">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-18">
            <a href="https://g7cloud.com/" data-id="element-19">
              <img className="h-10 w-auto" src="https://cdn.magicpatterns.com/uploads/1UMrPmCeSmFJKDo4KBzyQi/g7cloud-logo-2026-300x75.png" alt="G7Cloud" data-id="element-20" />
            </a>
          </div>

          {/* Main Navigation - Desktop */}
          <nav className="hidden md:flex space-x-8 items-center" onMouseLeave={() => setActiveDropdown(null)} data-id="element-21">
            <a href="https://g7cloud.com/domains/" className="text-gray-700 hover:text-g7-orange font-medium text-sm transition-colors py-2" data-id="element-22">
              Domains
            </a>

            {/* Solutions Dropdown */}
            <div className="relative group" onMouseEnter={() => setActiveDropdown('solutions')} onMouseLeave={() => setActiveDropdown(null)} data-id="element-23">
              <button className={`text-gray-700 group-hover:text-g7-orange font-medium text-sm inline-flex items-center transition-colors py-2 outline-none ${activeDropdown === 'solutions' ? 'text-g7-orange' : ''}`} aria-expanded={activeDropdown === 'solutions'} data-id="element-24">
                <span data-id="element-25">Solutions</span>
                <ChevronDown className={`ml-1 h-4 w-4 transition-transform duration-200 ${activeDropdown === 'solutions' ? 'rotate-180' : ''}`} data-id="element-26" />
              </button>

              <AnimatePresence data-id="element-27">
                {activeDropdown === 'solutions' && <motion.div initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: 10
              }} transition={{
                duration: 0.2
              }} className="absolute left-0 mt-0 w-72 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50 overflow-hidden" data-id="element-28">
                    <div className="py-2" data-id="element-29">
                      {solutionsLinks.map(item => <a key={item.name} href={item.href} className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-g7-orange transition-colors" data-id="element-30">
                          {item.name}
                        </a>)}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Features Dropdown */}
            <div className="relative group" onMouseEnter={() => setActiveDropdown('features')} onMouseLeave={() => setActiveDropdown(null)} data-id="element-31">
              <button className={`text-gray-700 group-hover:text-g7-orange font-medium text-sm inline-flex items-center transition-colors py-2 outline-none ${activeDropdown === 'features' ? 'text-g7-orange' : ''}`} aria-expanded={activeDropdown === 'features'} data-id="element-32">
                <span data-id="element-33">Features</span>
                <ChevronDown className={`ml-1 h-4 w-4 transition-transform duration-200 ${activeDropdown === 'features' ? 'rotate-180' : ''}`} data-id="element-34" />
              </button>

              <AnimatePresence data-id="element-35">
                {activeDropdown === 'features' && <motion.div initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: 10
              }} transition={{
                duration: 0.2
              }} className="absolute left-0 mt-0 w-64 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50 overflow-hidden" data-id="element-36">
                    <div className="py-2" data-id="element-37">
                      {featuresLinks.map(item => <a key={item.name} href={item.href} className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-g7-orange transition-colors" data-id="element-38">
                          {item.name}
                        </a>)}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            <a href="https://g7cloud.com/contact/" className="text-gray-700 hover:text-g7-orange font-medium text-sm transition-colors py-2" data-id="element-39">
              Contact Us
            </a>
          </nav>

          {/* Empty div to balance flex layout if needed, or just remove right actions */}
          <div className="hidden md:block w-px" data-id="element-40"></div>

          {/* Mobile menu button placeholder */}
          <div className="md:hidden flex items-center" data-id="element-41">
            <button className="text-gray-500 hover:text-gray-700 p-2" data-id="element-42">
              <span className="sr-only" data-id="element-43">Open menu</span>
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-44">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" data-id="element-45" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </motion.header>;
}